import React, {useEffect} from 'react'
import {ModalBase} from '../../../../components/Modals/ModalBase'
import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'
import {actionsGUEstadoDocumentos} from '../../../../actions/action-creators'
import {State} from '../../../../reducers'
import { generalOpenConfirmEdit } from '../../../../actions/general.actions'
import { validacionesOnBlurDocumentoSucursal } from '../../../../actions/gestion-usuario/gu-generales/gu-generales'
import { esNormativaV2 } from '../../../../utils/normativa.utils'
import {
  EJEMPLO_CODIGO_ESTABLECIMIENTO_V2,
  EJEMPLO_PUNTO_VENTA_V2,
} from '../../../../utils/series.utils'

const ModalAgregarDocumento = () => {
  const {formDocumento, errorsDocumento, dataSucursales} = useSelector((state: State) => state.gestionUsuario.sucursales)
  const {tipoDocumentosEmision, datosEmisor} = useSelector((state: State) => state.catalogos)
  const normativaV2 = esNormativaV2(datosEmisor)

  const dispatch = useDispatch()
  const acciones = bindActionCreators(actionsGUEstadoDocumentos, dispatch)

  useEffect(() => {
    return () => {
      dispatch(acciones.su_ClearFormDocSucursal())
    }
  }, [])

  const cancelar = () => dispatch(acciones.gu_ed_ShowModalCrearEditarSucursalDocumento(false))

  const crearDocumento = async (e: any) => {
    e.preventDefault();
    if(formDocumento.mode === 'add'){
      action_crearDocumento(e)
    } else {
      dispatch(generalOpenConfirmEdit(() => action_crearDocumento(e)))
    }
  }
  const action_crearDocumento = async (e: any) => {

    if (await acciones.su_validacionesCrearDocumentoSucursal()) return
    if (formDocumento.mode === "add") {
      await acciones.su_crearDocumento()
    } else {
      await acciones.su_editarDocumento()
    }
    acciones.su_getDocumentosSucursalesList();
  }

  const handleInputChange = (e: any) => {
    if (e.target.name === "idsucursal") {
      const sucursalElegida = dataSucursales.find((sucursal) => ""+sucursal.idsucursal === e.target.value);
      acciones.su_setFormDocSucursal({'codigoSucursal': sucursalElegida?.codigo});
    }
    acciones.su_FormDocSucursalHandleChange(e);
  }

  const handleInputBlur = (e: any) => {
    acciones.su_setErrorsFormDocSucursal({
      ...errorsDocumento,
      [e.target.name]: validacionesOnBlurDocumentoSucursal(
        e.target.name,
        e.target.value,
        normativaV2
      ),
    })
  }
  
  return (
    <ModalBase Styles={{minWidth: '30%', maxWidth: '700px', padding: '2%'}}>
      <form
        className='form-content'
        data-wf-page-id='64b58c72be2b65200b1e6fa6'
        data-wf-element-id='deb0f47f-468f-13fc-f1eb-4d36c39616dc'
        onSubmit={crearDocumento}
      >
        <div>
          <h3 className='card-title l'>
            {formDocumento.mode === "add" ? 'Agregar Documento' : 'Editar Documento'}
          </h3>
        </div>
        <div className='separador'></div>
        <div className='w-layout-hflex h-inputs'>
          <div className='label-input'>
            <label htmlFor='idsucursal' className='field-label m'>
              Sucursal
              <span style={{color: 'red'}}>*</span>
            </label>
            <select
              id='idsucursal'
              name='idsucursal'
              className='m text-field w-select'
              value={formDocumento.idsucursal}
              onChange={handleInputChange}
            >
              <option disabled value={''}>Selecciona una opción</option>
              {
                dataSucursales.map((sucursal) => (<option value={sucursal.idsucursal}>{sucursal.nombre}</option>))
              }
            </select>
            {errorsDocumento.idsucursal && <p className='alert s'>{errorsDocumento.idsucursal}</p>}
          </div>
          <div className='label-input'>
            <label htmlFor='documento' className='field-label m'>
              Documento a emitir
              <span style={{color: 'red'}}>*</span>
            </label>
            <select
              id='documento'
              name='documento'
              className='m text-field w-select'
              value={formDocumento.documento}
              onChange={handleInputChange}
            >
              <option disabled value={''}>Selecciona una opción</option>
              {
                tipoDocumentosEmision.map((doc) => (<option value={doc.iddocumento}>{doc.descripcion?.toUpperCase()}</option>))
              }
            </select>
            {errorsDocumento.documento && <p className='alert s'>{errorsDocumento.documento}</p>}
          </div>
        </div>
        <div className='w-layout-hflex h-inputs'>
          <div className='label-input'>
            <label htmlFor='codigoSucursal' className='field-label m'>
              Código sucursal
              <span style={{color: 'red'}}>*</span>
            </label>
            <input autoComplete="off"
              type='text'
              className='m text-field w-input'
              name='codigoSucursal'
              placeholder={normativaV2 ? EJEMPLO_CODIGO_ESTABLECIMIENTO_V2 : '0000'}
              id='codigoSucursal'
              value={formDocumento.codigoSucursal}
              onChange={handleInputChange}
              maxLength={4}
              disabled={true}
            />
            {errorsDocumento.codigoSucursal && <p className='alert s'>{errorsDocumento.codigoSucursal}</p>}
          </div>
          <div className='label-input'>
            <label htmlFor='numeroSucursal' className='field-label m'>
              Número sucursal
              <span style={{color: 'red'}}>*</span>
            </label>
            <input autoComplete="off"
              type='text'
              className='m text-field w-input'
              name='numeroSucursal'
              placeholder={normativaV2 ? EJEMPLO_PUNTO_VENTA_V2 : 'X000'}
              id='numeroSucursal'
              value={formDocumento.numeroSucursal}
              onChange={handleInputChange}
              onBlur={handleInputBlur}
              maxLength={4}
            />
            {errorsDocumento.numeroSucursal && <p className='alert s'>{errorsDocumento.numeroSucursal}</p>}
          </div>
        </div>
        <div className='w-layout-hflex h-inputs'>
          <div className='label-input'>
            <label htmlFor='resolucion' className='field-label m'>
              Resolución
              <span style={{color: 'red'}}>*</span>
            </label>
            <input autoComplete="off"
              type='text'
              className='m text-field w-input'
              name='resolucion'
              placeholder='Resolución'
              id='resolucion'
              value={formDocumento.resolucion}
              onChange={handleInputChange}
              maxLength={100}
            />
            {errorsDocumento.resolucion && <p className='alert s'>{errorsDocumento.resolucion}</p>}
          </div>
        </div>
        <div className='separador'></div>
        <div className='w-layout-hflex button-actions'>
          <button type='button' className='m button transparent w-inline-block' onClick={cancelar}>
            <div>Cancelar</div>
          </button>
          <button type='submit' className='m button w-inline-block'>
            <div>{formDocumento.mode === "add" ? 'Agregar' : 'Guardar'}</div>
          </button>
        </div>
      </form>
    </ModalBase>
  )
}

export default ModalAgregarDocumento
